export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  cover: string;
  publishedAt: string;
  source: string;
  category: string;
  author: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: "a001",
    title: "2026暑期档票房突破80亿，国产影片表现亮眼",
    excerpt: "截至7月底，2026年暑期档总票房已突破80亿元大关。多部国产影片凭借精良制作和动人故事获得观众好评，成为票房主力军。",
    content: `<p>截至2026年7月底，暑期档总票房已突破80亿元大关，创下新的票房纪录。其中，国产影片贡献了超过75%的票房份额，展现出中国电影市场的强劲活力。</p>
<p>今年暑期档亮点纷呈，《流浪地球3》《长安三万里2》等续作IP持续发力，新锐导演作品《追光》《赤焰》以黑马之姿闯入票房前列。中国电影工业的整体制作水平显著提升，视觉效果和叙事能力获得观众广泛认可。</p>
<p>业内人士分析，国产影片的持续走强得益于多方面因素：一是创作者更加注重内容品质和观众体验；二是中国传统文化与现代叙事手法的融合日趋成熟；三是影院基础设施不断完善，观影体验持续优化。</p>
<p>白云视频作为免费在线影视平台，将持续关注暑期档动态，为用户带来更多精彩影视资讯和优质观影推荐。</p>
<h3>暑期档热映推荐</h3>
<p>如果你还没去影院，不妨先来白云视频回顾这些经典前作，为新片预热。我们平台收录了多部系列电影的前作，高清画质、流畅播放，让你随时随地补课追影。</p>`,
    cover: "https://readdy.ai/api/search-image?query=Cinema%20box%20office%20concept%20with%20movie%20posters%20displayed%20in%20modern%20theater%20lobby%2C%20warm%20lighting%20with%20golden%20accents%2C%20clean%20modern%20interior%2C%20bright%20atmosphere%2C%20professional%20editorial%20photography&width=800&height=450&seq=article-boxoffice-01&orientation=landscape",
    publishedAt: "2026-07-28",
    source: "白云影视资讯",
    category: "industry",
    author: "影视观察员",
    tags: ["票房", "暑期档", "国产电影", "影视资讯"],
  },
  {
    id: "a002",
    title: "《庆余年2》大结局引发全网热议，网友：意犹未尽",
    excerpt: "年度热门剧集《庆余年》第二季迎来大结局，范闲的命运走向成为全网热议焦点。社交平台上相关话题阅读量已突破50亿次。",
    content: `<p>备受期待的《庆余年》第二季终于迎来大结局，范闲在经历了一系列惊心动魄的权谋斗争后，其命运走向引发了全网观众的热烈讨论。</p>
<p>第二季延续了第一季的精良制作水准，在剧情编排、人物塑造和世界观构建上更上一层楼。张若昀、陈道明、李沁等实力派演员的精湛演技更是为该剧增色不少。</p>
<p>社交平台上，#庆余年2大结局#话题阅读量已突破50亿次，网友们纷纷表达了对角色的不舍和对第三季的期待。有网友评论："最后一集看得我热泪盈眶，范闲这个角色塑造得太好了。"也有观众表示："意犹未尽，已经开始二刷了。"</p>
<p>在白云视频，你可以免费观看《庆余年》第一季全集，高清画质无广告，重温这个精彩故事的起点。</p>
<h3>剧集看点回顾</h3>
<p>从范闲入京都到鉴查院风云，从朝堂权谋到江湖恩怨，《庆余年》不仅是一部古装剧，更是一部关于成长、选择与坚守的史诗。如果你还没看过，现在就是最好的追剧时机。</p>`,
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20with%20palace%20courtyard%20and%20ancient%20Chinese%20architecture%2C%20warm%20golden%20sunset%20lighting%2C%20elegant%20traditional%20costumes%2C%20cinematic%20composition%2C%20soft%20atmospheric%20mood&width=800&height=450&seq=article-drama-02&orientation=landscape",
    publishedAt: "2026-08-01",
    source: "白云影视资讯",
    category: "review",
    author: "剧评人小王",
    tags: ["庆余年", "剧评", "古装剧", "张若昀"],
  },
  {
    id: "a003",
    title: "国漫崛起：从《斗罗大陆》到中国动画的黄金时代",
    excerpt: "近年来，中国动画产业实现了质的飞跃。从《斗罗大陆》到《哪吒》，国漫正在用自己的方式讲述精彩的中国故事。",
    content: `<p>曾几何时，国产动画还停留在低幼向的刻板印象中。而如今，从网络小说改编的《斗罗大陆》系列到现象级电影《哪吒之魔童降世》，中国动画正以惊人的速度崛起。</p>
<p>数据显示，2025年中国动漫产业总产值已突破3000亿元，年均增长率保持在20%以上。以《斗罗大陆》为代表的3D动画精品，在制作水准上已达到国际一流水平。《斗罗大陆II》在白云视频的热度持续走高，累计播放量突破百亿。</p>
<p>国漫崛起的背后，是技术的进步、资本的涌入，更是一代动画人的坚持与热爱。从二维到手绘再到三维CG，中国动画技术路线日趋成熟。同时，深厚的中国传统文化底蕴为国漫提供了取之不尽的创作源泉。</p>
<h3>白云视频动漫专区</h3>
<p>白云视频动漫频道收录了数百部优质国漫作品，从经典老番到最新连载，高清流畅免费看。无论你是资深二次元还是刚入坑的新人，都能在这里找到心仪的作品。</p>`,
    cover: "https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20concept%20with%203D%20character%20design%20display%20and%20creative%20workspace%2C%20modern%20digital%20art%20environment%2C%20warm%20ambient%20lighting%2C%20professional%20creative%20studio%20atmosphere&width=800&height=450&seq=article-anime-03&orientation=landscape",
    publishedAt: "2026-07-25",
    source: "白云影视资讯",
    category: "feature",
    author: "动漫迷小李",
    tags: ["国漫", "斗罗大陆", "动画产业", "中国动漫"],
  },
  {
    id: "a004",
    title: "暑期追剧指南：白云视频热门电视剧TOP10推荐",
    excerpt: "暑假已至，窝在沙发刷剧是最惬意的消遣方式。我们为你精心整理了白云视频最受欢迎的十部电视剧，总有一部适合你。",
    content: `<p>炎炎夏日，还有什么比开着空调、喝着冷饮、窝在沙发里追剧更惬意的事情呢？白云视频为你整理了这个暑期最值得一看的十部热门电视剧。</p>
<p><strong>TOP 1：狂飙</strong> - 故事从京海市开始，扫黑题材力作，张译、张颂文演技炸裂，豆瓣8.5分。</p>
<p><strong>TOP 2：庆余年·第二季</strong> - 范闲归来，权谋谋略更加精彩，演员阵容豪华。</p>
<p><strong>TOP 3：三体</strong> - 中国科幻电视剧的里程碑之作，特效和剧情双双在线。</p>
<p><strong>TOP 4：莲花楼</strong> - 武侠悬疑完美融合，成毅演技在线，制作精良。</p>
<p><strong>TOP 5：繁花</strong> - 王家卫首部电视剧，胡歌主演，九十年代上海风情画卷。</p>
<p>以上所有剧集均在白云视频免费播放，高清不卡顿，无需会员即可畅快追剧。这个暑假，让白云视频陪你度过每一个精彩的追剧之夜。</p>`,
    cover: "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20large%20TV%20screen%20displaying%20drama%20series%2C%20comfortable%20sofa%20with%20blankets%2C%20warm%20ambient%20lighting%2C%20relaxing%20home%20entertainment%20atmosphere%2C%20lifestyle%20photography&width=800&height=450&seq=article-tvguide-04&orientation=landscape",
    publishedAt: "2026-07-22",
    source: "白云影视资讯",
    category: "guide",
    author: "追剧达人",
    tags: ["追剧指南", "电视剧推荐", "暑期档", "热播剧"],
  },
  {
    id: "a005",
    title: "综艺市场新变局：慢综艺为何越来越受欢迎？",
    excerpt: "从《向往的生活》到《种地吧》，慢综艺正在成为观众的新宠。没有激烈的竞争和对抗，只有最真实的生活点滴。",
    content: `<p>在快节奏的都市生活中，慢综艺以其治愈、放松的特质，正越来越受到观众的喜爱。从《向往的生活》的田园牧歌，到《种地吧》的泥土芬芳，这些节目为观众提供了一个精神上的避风港。</p>
<p>数据显示，2026年上半年，慢综艺类节目的总播放量同比增长45%，远超竞技类综艺的18%。观众反馈中，"治愈""放松""真实"成为最高频的关键词。</p>
<p>业内人士认为，慢综艺的走红反映了当下社会心理的变化。在高压快节奏的生活中，人们渴望在荧幕上看到更接近生活本质的内容。这种趋势预计在未来几年仍将持续。</p>
<p>白云视频综艺频道汇集了当下最热门的慢综艺节目，《向往的生活》《种地吧》《你好生活》等高分综艺均可免费观看。</p>`,
    cover: "https://readdy.ai/api/search-image?query=Peaceful%20Chinese%20countryside%20farm%20with%20wooden%20house%20and%20garden%2C%20warm%20golden%20sunset%20light%2C%20rustic%20charm%2C%20tranquil%20rural%20lifestyle%20scene%2C%20beautiful%20nature%20landscape&width=800&height=450&seq=article-variety-05&orientation=landscape",
    publishedAt: "2026-07-18",
    source: "白云影视资讯",
    category: "feature",
    author: "综艺观察员",
    tags: ["综艺", "慢综艺", "向往的生活", "综艺趋势"],
  },
  {
    id: "a006",
    title: "免费观影新选择：为什么越来越多人选择白云视频？",
    excerpt: "在付费会员制盛行的今天，白云视频坚持免费高清路线，为用户提供了全新的观影选择。来看看用户们怎么说。",
    content: `<p>随着各大视频平台纷纷推出付费会员制度，免费的高质量影视内容变得越来越稀缺。白云视频正是在这样的背景下，以"免费高清、不卡顿"为核心理念，为用户开辟了一片新的观影天地。</p>
<p>白云视频的用户群体正在快速增长。平台数据显示，2026年上半年新增用户超过500万，日均活跃用户达300万。用户调研显示，"免费""高清画质""片源丰富"是用户选择白云视频的三大主要原因。</p>
<p>"我以前每个月要花几十块钱在视频会员上，自从发现白云视频后，省了一大笔开支。关键是画质真的很好，也不卡顿。"一位用户在社交平台上如此评价。</p>
<p>白云视频致力于打造中国最好的免费影视平台。我们持续优化播放体验，扩充内容库，让每一位用户都能享受到高质量的免费观影服务。</p>`,
    cover: "https://readdy.ai/api/search-image?query=Modern%20cozy%20living%20room%20with%20person%20watching%20movie%20on%20laptop%2C%20comfortable%20home%20setting%20with%20warm%20lighting%2C%20relaxed%20evening%20atmosphere%2C%20lifestyle%20concept%20photography&width=800&height=450&seq=article-platform-06&orientation=landscape",
    publishedAt: "2026-07-15",
    source: "白云影视资讯",
    category: "platform",
    author: "白云编辑",
    tags: ["白云视频", "免费影视", "观影体验", "平台动态"],
  },
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getArticlesByCategory = (category: string): Article[] => {
  return articles.filter((a) => a.category === category);
};

export const getLatestArticles = (count: number = 4): Article[] => {
  return [...articles].sort((a, b) => b.publishedAt.localeCompare(a.publishedAt)).slice(0, count);
};